import styled from "styled-components";

export const StyledContainer = styled("div")`
  display: inline-block;
  width: 100%;
  padding: 10px 5px;
  margin-bottom: -0.625rem;
`;


export const AddButtonContainer = styled("div")`
  margin-bottom:15px;
  display:flex;
  justify-content: right;
`;
